import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year6/Autumn/ConvertingUnits/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'ConvertingUnits',
  field: 'Measurement',
  weeks: [12, 12],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/ConvertingUnits/1MetricMeasures" */ './1MetricMeasures'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/ConvertingUnits/2ConvertMetricMeasures" */ './2ConvertMetricMeasures'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/ConvertingUnits/3CalculateWithMetricMeasures" */ './3CalculateWithMetricMeasures'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/ConvertingUnits/4MilesAndKilometres" */ './4MilesAndKilometres'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/ConvertingUnits/5ImperialMeasures" */ './5ImperialMeasures'
        )
    })
  ]
});
export default Block;
